import {
  RECEIVE_BANK_ACCOUNTS,
  RECEIVE_BANKS,
} from "./actionTypes";

const initialState = {
  bank_account: {},
  bank_accounts: [],
  banks: [],
}

export default function user(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_BANK_ACCOUNTS:
      return {
        ...state,
        bank_accounts: action.payload,
      };

    case RECEIVE_BANKS:
      const banks = action.payload.map((bank) => {
        return (
          { value: bank.id, label: bank.name }
        )
      })

      return {
        ...state,
        banks: banks,
      };
    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/features/banks/reducers.js